import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatDZ } from '../../../utils/currency';

const DashboardStats = ({ stats }) => {
  const statItems = [
    {
      id: 'orders',
      label: 'Total Orders',
      value: stats?.totalOrders,
      icon: 'Package',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/30'
    },
    {
      id: 'spent',
      label: 'Total Spent',
      value: `${formatDZ(stats?.totalSpent)}`,
      icon: 'DollarSign',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/30'
    },
    {
      id: 'wishlist',
      label: 'Wishlist Items',
      value: stats?.wishlistItems,
      icon: 'Heart',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/30'
    },
    {
      id: 'points',
      label: 'Loyalty Points',
      value: stats?.loyaltyPoints?.toLocaleString(),
      icon: 'Star',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      borderColor: 'border-secondary/30'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {statItems?.map((item) => (
        <div
          key={item?.id}
          className={`holographic-card p-6 rounded-lg ${item?.bgColor} border ${item?.borderColor} hover:scale-105 transition-all duration-300`}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground font-medium">{item?.label}</p>
              <p className={`text-2xl font-bold ${item?.color} mt-1`}>{item?.value}</p>
            </div>
            <div className={`p-3 rounded-lg ${item?.bgColor} border ${item?.borderColor}`}>
              <Icon name={item?.icon} size={24} className={item?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;